/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Status_UnpaidInputs */

const fr_membership_status_unpaid = /** @type {(inputs: Membership_Status_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impayé`)
};

/**

* @param {Membership_Status_UnpaidInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_status_unpaid = /** @type {((inputs?: Membership_Status_UnpaidInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Status_UnpaidInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_status_unpaid(inputs)
});